import ContentLoader from 'react-content-loader';

const HighlightCategoriesMobileLoader = (props: any) => (
    <ContentLoader
        speed={2}
        width={'100%'}
        height={'100%'}
        backgroundColor="#ececec"
        foregroundColor="#d6d6d6"
        {...props}>
        <circle cx="48" cy="28" r="24" />
        <rect x="26" y="60" rx="0" ry="0" width="44" height="9" />
        <rect x="26" y="75" rx="0" ry="0" width="44" height="9" />
    </ContentLoader>
);

export default HighlightCategoriesMobileLoader;
